/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetTradeByIdOptions, GetTradeByIdResponses } from '../types/GetTradeById'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get a trade by ID
 * {@link /v1/trades/:trade_id}
 */
export function getTradeById<ThrowOnError extends boolean = true>(
  options: Options<GetTradeByIdOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetTradeByIdResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/trades/{trade_id}',
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetTradeByIdResponses, ThrowOnError>>,
  )
}
